/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */
import React, { lazy, Suspense } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "../Body/Body.css";
import Signupfrom from "../../components/SignUpForm.js";
const Script = lazy(() => import('../widgets/widget'));
 
export default function Body( ) {
  
  return (
    <>
      <div className="banner">
        <Container>
          <Row>
            <Col sm={12} md={12} xl={7} lg={7}>
              <div className="bannerspace">
                <p className="seamlessmortgage">
                  AngelAi - Empowering Seamless Mortgage Lending by Financial
                  Institutions
                </p>
                <p className="pathtext">
                  Your Path to Efficient and Compliant Mortgage Lending
                </p>
              </div>
            </Col>
            <Col sm={12} md={12} xl={5} lg={5}>
              <div className="bannerspace">
            
                <Signupfrom />
             
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <Suspense fallback={<div>loading...</div>}>
     <Script />
 </Suspense>
    </>
  );
}
